<template>
  <div class="exam-calc">
    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <md-input-container>
          <label>Testosterona total (ng/dL)</label>
          <md-input
            id="testosterona"
            v-model="exam.fields.testosterona"
            v-validate="'required'"
            v-mask="mask"
            data-vv-validate-on="none"
            name="testosterona"
            title="Testosterona total (ng/dl)"
            placeholder="Testosterona total (ng/dL)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.testosterona"
            v-mask="mask"
            type="hidden"
          >
        </md-input-container>

        <md-input-container>
          <label>SHBG (nmol/L)</label>
          <md-input
            id="shbg"
            v-model="exam.fields.shbg"
            v-validate="'required'"
            v-mask="mask"
            data-vv-validate-on="none"
            name="shbg"
            title="SHBG (nmol/L)"
            placeholder="SHBG (nmol/L)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.shbg"
            v-mask="mask"
            type="hidden"
          >
        </md-input-container>
        <button
          class="btn btn-primary btn-calc"
          @click="calculate()"
        >
          Calcular
        </button>
      </md-layout>
    </md-layout>

    <div class="calc-card__result">
      <template>
        <p>
          Resultado: <span>{{ exam.result }}</span>
        </p>
      </template>
    </div>
  </div>
</template>
<script>

import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'CalcSuperfícieCorporal',

  data: () => {
    return {
      exam: {
        fields: {
          testosterona: null,
          shbg: null
        },
        result: 0
      },
      mask: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 1,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 3
      })
    }

  },
  methods: {
    calculate() {
      if (this.exam.fields.testosterona && this.exam.fields.shbg) {
        const testosterona = +this.exam.fields.testosterona
        const shbg = +this.exam.fields.shbg
        const calc = (testosterona/100 * 3.467*100 / shbg).toFixed(1)
        this.exam.result = calc
      }
    }
  }
}
</script>

